import { DateTime } from 'luxon';

export interface UserProfile {
  amr: string;
  auth_time: DateTime;
  sub: string;
  idp: string;
  name: string;
  email: string;
  email_verified: boolean;
  preferred_username: string;
  first_name: string;
  last_name: string;
  initials: string;
  is_cms_user: boolean;
  avatar_color: string;
  role: Role[];
  allSitesEnabled: boolean;
  sites: string[];
}

export enum Role {
  SuperAdmin = 'SuperAdmin',
  ITAdmin = 'ITAdmin',
  Finance = 'Finance',
  FinanceBanking = 'FinanceBanking',
  OpsAdmin = 'OpsAdmin',
  WineSales = 'WineSales',
  StorageSales = 'StorageSales',
  CellarManager = 'CellarManager',
  CellarAssistant = 'CellarAssistant',
  Reporting = 'Reporting',
  Support = 'Support',
}
